import { render, staticRenderFns } from "./TournamentClubCostDeduction.vue?vue&type=template&id=f021c01c&scoped=true&"
import script from "./TournamentClubCostDeduction.vue?vue&type=script&lang=js&"
export * from "./TournamentClubCostDeduction.vue?vue&type=script&lang=js&"
import style0 from "./TournamentClubCostDeduction.vue?vue&type=style&index=0&id=f021c01c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f021c01c",
  null
  
)

export default component.exports